// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row {
  width: 100%;
}
ion-row .flex-end {
  display: flex;
  justify-content: flex-end;
}

.withdraw-data {
  margin-top: 0;
}
.withdraw-data ion-item {
  border: 1px solid #DDDDDD;
  border-right: unset;
  border-left: unset;
  border-radius: 4px;
  margin-bottom: 5px;
}
.withdraw-data ion-list ion-row {
  --ion-margin: 11px;
}

.text-bold {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/withdraw/withdrawal-reverse/withdrawal-reverse.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AACI;EACI,aAAA;EACA,yBAAA;AACR;;AAGA;EACI,aAAA;AAAJ;AAEI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAAR;AAGI;EACI,kBAAA;AADR;;AAKA;EACI,iBAAA;AAFJ","sourcesContent":["ion-row {\r\n    width: 100%;\r\n\r\n    .flex-end {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n    }\r\n}\r\n\r\n.withdraw-data {\r\n    margin-top: 0;\r\n\r\n    ion-item {\r\n        border: 1px solid #DDDDDD;\r\n        border-right: unset;\r\n        border-left: unset;\r\n        border-radius: 4px;\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    ion-list ion-row {\r\n        --ion-margin: 11px;\r\n    }\r\n}\r\n\r\n.text-bold {\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
